<template>
<div class="lastpage">
  <div class="w">
    <ul>
      <li>
        <div class="mdfe">关于我们</div>
        <p @click="$router.push('/mains')">公司简介</p>
        <p @click="$router.push('/mased')">平台优势</p>

      </li>
       <li>
        <div class="mdfe">新闻资讯</div>
        <p>行业动态</p>
        <p @click="$router.push('/industry')">行业资讯</p>

      </li>
     <li>
        <div class="mdfe">运营模式</div>
        <p  @click="$router.push('/alge')">合作案例</p>
        <p  @click="$router.push('/handrs')">合作伙伴</p>
      </li>
       <li>
        <div class="mdfe">联系我们</div>
        <p class="ip">地址：上海市静安区灵石路718号大宁中心广场三期B1栋南楼520室</p>
         <div class="mote">
         <img src="../assets/image/email.png" alt="">
         <p class="emadil">邮箱：kevinsong@hundredzy.com</p>
        </div>
      </li>
       <li>
        <div class="mefires">
          <img src="../assets/img/ewm.png" alt="">
          <s></s>
        </div>
        <span>移动端预览</span>
      </li>
    </ul>
    <div class="last-page-footer">
        <div class="laset_fird">友情链接</div>
        <ol>
          <li>
              <a href="https://www.wesdom.me" class="text">微思敦移动营销</a>
                <div class="cols"></div>
          </li>
           <li>
              <a href="https://www.appganhuo.com" class="text">APP干货铺子</a>
                <div class="col"></div>
          </li>
           <li>
              <a href="https://www.liangjianghu.com" class="text">量江湖ASM</a>
                <div class="col"></div>
          </li>
           <li>
              <a  href="https://zhugeio.com" class="text">诸葛io</a>
                <div class="col"></div>
          </li>
           <li>
              <a href="https://www.thinkingdata.cn" class="text">手游那点事</a>
                <div class="col"></div>
          </li>
           <li>
              <a href="javascript:;" class="text">DevStore</a>
                <div class="col"></div>
          </li>
           <li>
              <a href="https://www.apicloud.com/" class="text">蝉大师运营圈</a>
                <div class="col"></div>
          </li>
           <li>
              <a href="https://www.27sem.com" class="text">艾奇学院</a>
                <div class="col"></div>
          </li>
           <li>
              <a href="javascript:;" class="text">执牛耳</a>
                <div class="col"></div>
          </li>
           <li>
              <a href="http://www.zhiniuer.net"  class="text">易观</a>
                <div class="col"></div>
          </li>
           <li>
              <a href="http://xueyuan.zhugeio.com" class="text">诸葛学院</a>
                <div class="col"></div>
          </li>
           <li>
              <a href="https://www.umeng.com/" class="text">热云数据</a>
                <div class="col"></div>
          </li>
           <li>
              <a href="http://hzqfyx.com" class="text">企服优选</a>
                <div class="col"></div>
          </li>

        </ol>
    </div>
    <div class="mde"></div>
    <div class="ge">

    </div>
    <div class="recod" >
      <img src="../assets/image/mat.gif" alt="">
       <a href="  https://beian.miit.gov.cn/">沪ICP备19029700号-1  © 致源广告 All Reserved </a>
    </div>
  </div>
</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
 .lastpage {
     margin-top: 96px;
     height: 354px;
     background-color: #353A45;
     .w {

       ul {
         cursor: pointer;
         display: flex;
         padding-top: 50px;
     li {
          margin-right: 50px;
       .mdfe {
        width: 88px;
        height: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 40px;
        margin-bottom: 27px;

       }
       p {
         height: 21px;
          margin-bottom: 20px;
          color: #fff;
          width: 67px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 33px;
       }
       .ip {
         width: 507px;
        height: 17px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 33px;
       }
       .mote {
         display: flex;
          p {
            a:hover {
              color: rgb(73, 144, 255);
            }
          }
         img {
           width: 18px;
           height: 14px;
         margin-top: 8px;
         margin-right: 10px;
         }
       .emadil {
         width: 293px;
         height: 18px;
         font-size: 16px;
         font-family: Microsoft YaHei;
         font-weight: 400;
         color: #FFFFFF;
         line-height: 33px;
       }

       }
      .mefires {

        position: relative;
        s {
          width: 118px;
         height: 16px;
         background: url(../assets/img/xian.png) no-repeat;
         position: absolute;
         top: 50%;
         left: 50%;
         margin: -8px 0 0 -59px;

        -webkit-animation: light 2.5s linear infinite 300ms 0 ease;
        -moz-animation: light 2.5s linear infinite 300ms 0 ease;
        -ms-animation: light 2.5s linear infinite 300ms 0 ease;
        animation: light 2.5s linear infinite 300ms 0 ease;
        -moz-animation: light 2.5s linear infinite;
        /* -webkit-animation: light 2.5s linear infinite; */
        -o-animation: light 2.5s linear infinite;
        -ms-animation: light 2.5s linear infinite;
        animation: light 2.5s linear infinite;
        @keyframes light {
        0% {
    -webkit-transform: translateY(-40px);
    -moz-transform: translateY(-40px);
    -ms-transform: translateY(-40px);
    -o-transform: translateY(-40px);
    transform: translateY(-40px);
          }

        50% {
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px);
         }

        100% {
    -webkit-transform: translateY(-40px);
    -moz-transform: translateY(-40px);
    -ms-transform: translateY(-40px);
    -o-transform: translateY(-40px);
    transform: translateY(-40px);
        }
        }

        }
    width: 120px;
    height: 120px;
    background: #FFFFFF;
     margin-left:117px;
       }
       span {
         display: block;
         text-align: center;
         margin-left: 117px;
         margin-top: 12px;
         color: #fff;
       }
     }
   }
   .last-page-footer {
      //  margin-top: 30px;
       ol {
     display: flex;
       li {
         margin-right:30px;
          .text {
        display: block;
       height: 14px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 33px;
          }

        .col {
          width: 1px;
          height: 12px;
          background-color: #CCC8CB;
            margin-left: -14px;
           margin-top: -2px;

        }
       }

     }
     .laset_fird {
    height: 18px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 40px;
    margin-bottom: 22px;
     }

      }
     }
      .mde {
     border-bottom: 1px solid rgba(255,255,255,.1);
     margin-top:27px;
   }
   .ge {
     a {

     }
   }
  .recod {
    letter-spacing: 1px;
    margin-top: 20px;
    text-align: center;
    a:hover{
      color: rgb(73, 144, 255);
    }
    img {
      width: 10px;
      height: 14px;
      display: inline-block;
      vertical-align: middle;
    }
  }
   }
</style>
